/**
 * CashRegister — a custom lucide-style icon for the "Register" nav tab (Jose 2026-10-30).
 *
 * lucide-react doesn't ship a cash-register glyph, so this hand-drawn one matches the register image Jose
 * wanted while keeping the SAME visual language as the other nav icons (24×24, stroke, round caps). Drops
 * into any `icon:` slot that renders `<Icon className="h-6 w-6" />`; also accepts size/strokeWidth/color like
 * a real lucide icon.
 */
import React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  size?: number | string;
  strokeWidth?: number | string;
}

export const CashRegister: React.FC<Props> = ({ size = 24, strokeWidth = 2, className, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...props}
  >
    {/* raised display / receipt head */}
    <rect x="5" y="3" width="9" height="4.5" rx="1" />
    {/* neck connecting the display to the body */}
    <path d="M9.5 7.5V10" />
    {/* register body + drawer */}
    <rect x="3" y="10" width="18" height="10" rx="2" />
    {/* seam between the key deck and the drawer */}
    <path d="M3 13.5h18" />
    {/* drawer handle */}
    <path d="M7 16.9h4" />
    {/* total / sale button */}
    <circle cx="16.5" cy="16.9" r="1" />
  </svg>
);

export default CashRegister;
